import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(() => {
    try { return JSON.parse(localStorage.getItem('cf_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  // Verify token on mount
  useEffect(() => {
    const token = localStorage.getItem('cf_token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me')
      .then(r => setUser(r.data.data))
      .catch(() => { localStorage.removeItem('cf_token'); localStorage.removeItem('cf_user'); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('cf_token', r.data.token);
    localStorage.setItem('cf_user',  JSON.stringify(r.data.data));
    setUser(r.data.data);
    return r.data.data;
  }, []);

  const register = useCallback(async (data) => {
    const r = await api.post('/auth/register', data);
    localStorage.setItem('cf_token', r.data.token);
    localStorage.setItem('cf_user',  JSON.stringify(r.data.data));
    setUser(r.data.data);
    return r.data.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('cf_token');
    localStorage.removeItem('cf_user');
    setUser(null);
  }, []);

  const updateUser = useCallback((updated) => {
    setUser(updated);
    localStorage.setItem('cf_user', JSON.stringify(updated));
  }, []);

  const isAdmin = user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
